<template>
    <div>
        <div class="com-page-title">
            <div class="inner">{{ $route.meta.title }}</div>
        </div>
        <div class="com-card">
            <div class="com-card-title">{{ year }}  ·  年度法会（农历）</div>
            <div class="com-card-content">
                <van-list
                    v-model:loading="loading"
                    :finished="finished"
                    @load="getList"
                >
                    <ul class="com-list-cell" v-if="list.length">
                        <li v-for="lst in list" :key="lst.id" @click="nextStep(lst)">
                            <div class="title">
                                <span>{{ lst.name?.replace(/\n/gi, '') }} </span><font>{{ lst.date }}</font>
                            </div>
                            <div class="category c2" v-if="!endFlag(lst)">
                                <span>报名截止</span>
                            </div>
                            <template v-else>
                                <div :class="`category c${['gongfeng', 'baoming'].includes(lst.participateWay) ? '1' : '2'}`">
                                    <van-icon name="play" color="#F0D48F" v-if="['gongfeng', 'baoming'].includes(lst.participateWay)" />
                                    <DictionaryText typeCode="canyufangshi" :dictValue="lst.participateWay"/>
                                </div>
                            </template>
                        </li>
                    </ul>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import DictionaryText from '@/components/common/DictionaryText'
    import calendar from '@/utils/LularCalendar'
    import { getUserInfo } from '@/utils/auth'
    import realRegisterTip from '@/utils/RealRegisterTip'
    export default {
        data () {
            return {
                userInfo: getUserInfo(),
                loading: false,
                finished: false,
                list: [],
                page: 1,
                limit: 10
            }
        },
        methods: {
            
            // 查询分类列表
            getList () {
                this.$faWuApi.faHui.list({
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.success) {
                        const data = res.data
                        if (data.list.length < this.limit) {
                            this.finished = true
                        }

                        this.page ++
                        this.list = this.list.concat(data.list)
                        this.loading = false
                    } else {
                        this.$toast(res.errMessage)
                    }
                })
            },
            // 链接跳转
            nextStep (item) {
                if (!item.deadline || new Date(item.deadline).getTime() > Date.now()) {
                    // 牌位供奉
                    if (item.participateWay == 'gongfeng') {
                        // 已实名用户才能进入下一页
                        if (this.userInfo.status == 1) {
                            this.$router.push({
                                path: 'fahui/sub-list',
                                query: { pId: item.id }
                            })
                        } else {
                            realRegisterTip()
                        }
                    }
                    // 登记报名
                    else if (item.participateWay == 'baoming') {
                        // 已实名用户才能进入下一页
                        if (this.userInfo.status == 1) {
                            this.$router.push({
                                path: 'fahui/reg-detail',
                                query: { pId: item.id }
                            })
                        } else {
                            realRegisterTip()
                        }
                    }
                }
            },
            // 判断法会是否已经到截止日期
            endFlag (item) {
                if (!item.deadline) {
                    return true
                }
                return new Date(item.deadline).getTime() > Date.now()
            }
        },
        components: {
            DictionaryText
        },
        computed: {
            year () {
                const year = new Date().getFullYear()
                // const time = calendar.solar2lunar(`${new Date().getFullYear()}`,`${new Date().getMonth() + 1}`,`${new Date().getDate()}`)
                const time = calendar.solar2lunar(`${new Date().getFullYear()}`, '6', '1')
                return `${year}${time.gzYear}`
            }
        }
    }
</script>